import { render, staticRenderFns } from "./veHqChurukuReturn.vue?vue&type=template&id=61b670a4&scoped=true"
import script from "./veHqChurukuReturn.vue?vue&type=script&lang=js"
export * from "./veHqChurukuReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b670a4",
  null
  
)

export default component.exports